import { TournamentCalendarModel } from './tournamentCalendarModel';

export interface TournamentReferenceModel {
  tournamentId?: string;
  name?: string;
  start?: Date;
  end?: Date;
  rank?: string;
  category?: string;
}

export function tournamentCalendarToRefference(
  tournamentCalendar: TournamentCalendarModel,
): TournamentReferenceModel {
  return {
    tournamentId: tournamentCalendar._id,
    name: tournamentCalendar.name,
    start: tournamentCalendar.start,
    end: tournamentCalendar.end,
    rank: tournamentCalendar.rank,
    category: tournamentCalendar.category,
  };
}
